export default [
  {
    path:
      '/my-location/:cityId/branches/:branchId/establishments/:establishmentId',
    redirect: to => ({
      ...to,
      name: 'company',
      params: {
        ...to.params,
        companyId: to.params.establishmentId,
      },
    }),
    props: true,
    children: [
      {
        path: 'sections/:sectionId',
        props: true,
        redirect: to => ({
          ...to,
          name: 'companySection',
          params: {
            ...to.params,
            companyId: to.params.establishmentId,
          },
        }),
      },
    ],
  },
]
